<div class="scv2-section">
  <div class="scv2-section-head">
    <h2 class="scv2-h2">Shipping carriers</h2>
    <p class="scv2-sub">
      <!-- TODO re-enable UPS + labels: Connect UPS or USPS so customers can see real shipping costs and you can buy + print labels straight from LincSell. -->
      Connect USPS so customers can see real shipping costs at checkout.
    </p>
  </div>

  <div class="scv2-carrier-grid">
    <div class="scv2-card" *ngFor="let id of carrierIds">
      <div class="scv2-carrier-head">
        <app-carrier-mark-v2 [carrierId]="id"></app-carrier-mark-v2>
        <div>
          <div class="scv2-carrier-name">{{ carriers[id].name }}</div>
          <div class="scv2-carrier-tagline">{{ carriers[id].tagline }}</div>
        </div>
        <div class="scv2-carrier-status">
          <span *ngIf="connections[id]" class="scv2-badge scv2-badge-green">Connected</span>
          <span *ngIf="!connections[id]" class="scv2-badge scv2-badge-gray">Not connected</span>
        </div>
      </div>

      <!-- Not connected -->
      <ng-container *ngIf="!connections[id]">
        <!-- account guide -->
        <div class="scv2-guide">
          <button type="button" class="scv2-guide-toggle" (click)="toggleGuide(id)">
            <i class="pi pi-question-circle"></i>
            {{ guideOpen[id] ? 'Hide the guide' : 'New to ' + carriers[id].name + '? Here\'s an easy guide' }}
            <i class="pi" [ngClass]="guideOpen[id] ? 'pi-chevron-up' : 'pi-chevron-down'" style="margin-left:auto"></i>
          </button>

          <div *ngIf="guideOpen[id]" class="scv2-guide-body">
            <div class="scv2-guide-title">Getting set up with {{ carriers[id].name }} — step by step</div>
            <div class="scv2-guide-steps">
              <div class="scv2-guide-step" *ngFor="let s of accountSteps[id]; let i = index">
                <div class="scv2-guide-step-num">{{ i + 1 }}</div>
                <div class="scv2-guide-step-text">
                  {{ s.text }}
                  <span *ngIf="s.tag === 'auto'" class="scv2-badge scv2-badge-blue">Only if you want it automatic</span>
                  <span *ngIf="s.tag === 'manual'" class="scv2-badge scv2-badge-gray">Only if you'll do it yourself</span>
                </div>
              </div>
            </div>

            <div class="scv2-guide-title">Which one's right for you?</div>
            <div class="scv2-compare">
              <div class="scv2-compare-grid">
                <div class="scv2-compare-h"></div>
                <div class="scv2-compare-h scv2-center">Connect automatically</div>
                <div class="scv2-compare-h scv2-center">I'll ship it myself</div>

                <div class="scv2-compare-c scv2-muted">Shows real prices to customers</div>
                <div class="scv2-compare-c scv2-center scv2-green">Yes</div>
                <div class="scv2-compare-c scv2-center scv2-muted">No — one flat price</div>

                <!-- TODO re-enable labels: label-printing compare row hidden while buy+print labels is off
                <div class="scv2-compare-c scv2-muted">Prints labels here in LincSell</div>
                <div class="scv2-compare-c scv2-center scv2-green">Yes</div>
                <div class="scv2-compare-c scv2-center scv2-muted">No — ship elsewhere, add tracking #</div>
                -->

                <div class="scv2-compare-c scv2-muted">What {{ carriers[id].name }} gives you</div>
                <div class="scv2-compare-c scv2-center scv2-dark">Two codes, by email</div>
                <div class="scv2-compare-c scv2-center scv2-dark">Just your account number</div>
              </div>
            </div>

            <a [href]="developerUrl(id)" target="_blank" rel="noreferrer" class="scv2-guide-link" (click)="$event.preventDefault()">
              <i class="pi pi-external-link"></i> Take me to {{ carriers[id].name }}'s sign-up page
            </a>
          </div>
        </div>

        <p class="scv2-card-hint">
          Choose how you'd like to set this carrier up. You can switch later in account settings.
        </p>
        <div class="scv2-setup-options">
          <button type="button" class="scv2-setup-option" (click)="openModal(id, 'api')">
            <div class="scv2-setup-icon scv2-orange-bg"><i class="pi pi-bolt"></i></div>
            <div class="scv2-setup-option-main">
              <div class="scv2-setup-option-title">Connect via API <span class="scv2-recommended">Recommended</span></div>
              <!-- TODO re-enable labels: Live rates, buy + print labels, auto tracking -->
              <div class="scv2-setup-option-desc">Live rates and auto tracking</div>
            </div>
            <i class="pi pi-chevron-right scv2-muted"></i>
          </button>
        </div>
      </ng-container>

      <!-- Connected -->
      <ng-container *ngIf="connections[id] as conn">
        <div class="scv2-conn-badges">
          <span class="scv2-badge scv2-badge-blue">{{ conn.mode === 'api' ? 'API connection' : 'Manual mode' }}</span>
          <span *ngIf="conn.mode === 'api'" class="scv2-badge scv2-badge-green">Live rates on</span>
        </div>
        <div class="scv2-conn-info">
          <ng-container *ngIf="conn.mode === 'api'">
            <div>Account #: {{ conn.accountNumber || '—' }}</div>
            <div>Environment: {{ conn.env || 'Production' }}</div>
          </ng-container>
          <ng-container *ngIf="conn.mode === 'manual'">
            <div>Account #: {{ conn.accountNumber || '—' }}</div>
            <div>Pickup contact: {{ conn.contactName || '—' }}</div>
          </ng-container>
        </div>
        <div class="scv2-conn-actions">
          <button type="button" class="scv2-btn-ghost" (click)="openModal(id, conn.mode)"><i class="pi pi-pencil"></i> Manage</button>
          <button type="button" class="scv2-btn-ghost scv2-danger-btn" (click)="disconnect(id)"><i class="pi pi-trash"></i> Disconnect</button>
        </div>
      </ng-container>
    </div>
  </div>

  <div *ngIf="anyConnected" class="scv2-nudge">
    <i class="pi pi-shield"></i>
    <p>
      Nice — at least one carrier is connected. Head to <b>Shipping rules</b> to decide how rates are shown at checkout.
    </p>
    <button type="button" class="scv2-link-btn" (click)="goToRules.emit()">Set up rules →</button>
  </div>
</div>

<!-- Connect modal -->
<p-dialog
  *ngIf="modal"
  [visible]="true"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [dismissableMask]="true"
  (onHide)="closeModal()"
  [style]="{ width: '560px', maxWidth: '94vw' }"
  styleClass="scv2-dialog"
>
  <ng-template pTemplate="header">
    <div class="scv2-dialog-head">
      <h3>{{ (modal.mode === 'api' ? 'Connect' : 'Manual setup') + ' — ' + carriers[modal.carrier].name }}</h3>
      <p>{{ modal.mode === 'api' ? 'Enter the API credentials from your carrier developer account.' : "We'll save these details so you can ship orders without live rates." }}</p>
    </div>
  </ng-template>

  <!-- API mode -->
  <ng-container *ngIf="modal.mode === 'api'">
    <div class="scv2-field">
      <label>Client ID / API Key <span class="scv2-req">*</span></label>
      <input class="scv2-input" [placeholder]="'e.g. ' + (modal.carrier | uppercase) + '-CK-83JK...'" [(ngModel)]="form.clientId" />
    </div>
    <div class="scv2-field">
      <label>Client Secret <span class="scv2-req">*</span></label>
      <input class="scv2-input" type="password" placeholder="••••••••••••" [(ngModel)]="form.clientSecret" />
    </div>
    <div class="scv2-field">
      <label>Account Number <span class="scv2-req">*</span></label>
      <input class="scv2-input" placeholder="6-digit shipper account number" [(ngModel)]="form.accountNumber" />
    </div>
    <div class="scv2-field">
      <label>Environment</label>
      <div class="scv2-env-row">
        <button type="button" *ngFor="let env of ['Sandbox', 'Production']" class="scv2-env-btn" [class.scv2-active]="form.env === env" (click)="form.env = env">{{ env }}</button>
      </div>
    </div>
    <div class="scv2-test-row">
      <button type="button" class="scv2-btn-ghost" (click)="testConnection()">
        <i class="pi pi-bolt"></i> {{ testState === 'testing' ? 'Testing…' : 'Test connection' }}
      </button>
      <span *ngIf="testState === 'ok'" class="scv2-test-ok"><i class="pi pi-check-circle"></i> Connected successfully</span>
    </div>
    <p class="scv2-note">
      Don't have API credentials yet? Create them from the {{ carriers[modal.carrier].name }} developer portal — it usually takes about 10 minutes.
    </p>
    <div class="scv2-dialog-actions">
      <button type="button" class="scv2-btn-ghost scv2-full" (click)="closeModal()">Cancel</button>
      <button type="button" class="scv2-btn-primary scv2-full" [disabled]="testState !== 'ok'" (click)="saveConnection()"><i class="pi pi-check"></i> Save &amp; connect</button>
    </div>
  </ng-container>

  <!-- Manual mode -->
  <ng-container *ngIf="modal.mode === 'manual'">
    <div class="scv2-info-box scv2-orange-box">
      <i class="pi pi-question-circle"></i>
      <p>
        <!-- TODO re-enable labels: trailing sentence originally read "No live rates, no labels bought or printed in LincSell." -->
        <b>What manual mode means:</b> you keep shipping with {{ carriers[modal.carrier].name }} the normal way — their website, app, or a drop-off counter. LincSell just stores your account info below and lets you paste in the tracking number after you ship, so the customer gets notified. No live rates in LincSell.
      </p>
    </div>

    <div *ngIf="!form.accountNumber" class="scv2-manual-hint">
      Don't have a {{ carriers[modal.carrier].name }} account number yet? {{ manualAccountHint[modal.carrier] }}
    </div>

    <div class="scv2-field">
      <label>Carrier account number <span class="scv2-req">*</span></label>
      <input class="scv2-input" placeholder="Account # printed on your carrier agreement" [(ngModel)]="form.accountNumber" />
    </div>
    <div class="scv2-field">
      <label>Pickup contact name <span class="scv2-req">*</span></label>
      <input class="scv2-input" placeholder="Who carriers should ask for at pickup" [(ngModel)]="form.contactName" />
    </div>
    <div class="scv2-grid-2">
      <div class="scv2-field">
        <label>Street address <span class="scv2-req">*</span></label>
        <input class="scv2-input" placeholder="123 Market St" [(ngModel)]="form.street" />
      </div>
      <div class="scv2-field">
        <label>City <span class="scv2-req">*</span></label>
        <input class="scv2-input" placeholder="Lahore" [(ngModel)]="form.city" />
      </div>
    </div>
    <div class="scv2-grid-2">
      <div class="scv2-field">
        <label>State / Province</label>
        <input class="scv2-input" placeholder="Punjab" [(ngModel)]="form.state" />
      </div>
      <div class="scv2-field">
        <label>ZIP / Postal code <span class="scv2-req">*</span></label>
        <input class="scv2-input" placeholder="54000" [(ngModel)]="form.zip" />
      </div>
    </div>
    <div class="scv2-field">
      <label>Default service level</label>
      <div class="scv2-select-wrap">
        <select class="scv2-select" [(ngModel)]="form.service">
          <option>Ground</option>
          <option>Priority</option>
          <option>Express</option>
        </select>
        <i class="pi pi-chevron-down"></i>
      </div>
    </div>
    <div class="scv2-info-box scv2-gray-box">
      <i class="pi pi-exclamation-circle"></i>
      <p>
        <!-- TODO re-enable labels: originally "Manual mode: no live rates and no labels printed here." -->
        Manual mode: no live rates here. After you ship, type in the tracking number and LincSell passes it to the customer.
      </p>
    </div>
    <div class="scv2-dialog-actions">
      <button type="button" class="scv2-btn-ghost scv2-full" (click)="closeModal()">Cancel</button>
      <button type="button" class="scv2-btn-primary scv2-full" (click)="saveConnection()"><i class="pi pi-check"></i> Save details</button>
    </div>
  </ng-container>
</p-dialog>
